/** For unsaved dashboards represented in template form in REALM */
export const DASHBOARD_TEMPLATE_RESOURCE = 'dashboardTemplate';
/** A saved dashboard with ID */
export const DASHBOARD_RESOURCE = 'dashboard';
/** @deprecated Only for use in extremely rare circumstances, reach out before use */
export const TRANSIENT_DASHBOARD_RESOURCE = 'transientDashboard';

// TODO: add type
// TODO: add type